//Imports node_modules
import React, { useState, useContext } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

//Import Data
import { globalVariables } from './GlobalVariables'
import { globalModals } from "./GlobalModals";

//Variaveis inicias
const initialState = {
    //Variaveis para a função advancedClick
    lastTouchTimeStamp: Date.now(),
    lastMouseTimeStamp: Date.now(),
    lastClickTimeStamp: Date.now(),
}

export const globalFunctions = React.createContext(initialState)

const GlobalFunctions = params => {

    const [state, setState] = useState(initialState)

    const {
        apiBaseUrl,
    } = useContext(globalVariables)

    const {
        ShowMessageModal,
        ShowFormModal,
        DismisFormModal,
    } = useContext(globalModals);


    //Tbm pode ter o removeCookie 
    const cookies = new Cookies();

    const navigate = useNavigate();

    //Este onClick serve para evitar o duplo click
    async function advancedClick(event, executa) {
        
        //Ordem de eventos
        //1- touchstart
        //2- touchend
        //3- mousedown
        //4- mouseup
        //5- click

        //1
        if (event.type === "touchstart") {
            setState({ ...state, lastTouchTimeStamp: Date.now() })
            return;
        }

        //2
        if (event.type === "touchend") {
            //Caso o utilizador arraste o dedo durante demasiado tempo
            //Não pode ser menor do que 150 porque se a app estiver lenta ele deixa de detetar os clicks
            if ((Date.now() - state.lastTouchTimeStamp) < 160) {
                executa()
            }
            return;
        }

        //3
        if (event.type === "mousedown") {
            setState({...state, lastMouseTimeStamp: Date.now()})
            return;
        }

        //5
        if (event.type === "click") {
            //Como não processo o evento de mouse só preciso de verifiar o ultimo click
            if((Date.now() - state.lastTouchTimeStamp) > 400){
                if((Date.now() - state.lastMouseTimeStamp) < 160){
                    executa()
                }
            }
            return;
        }
    }

    function saveDispName(fields) {
        var uniqueID;
        uniqueID = cookies.get('uniqueDeviceID');

        
        axios.post(apiBaseUrl + 'UniqueIdDisp/insertNewUniqueID?uniqueId=' + uniqueID + '&name=' + fields[0].value, { timeout: 50000 }).then((response) => {
            if (response.data === uniqueID) {

                localStorage.setItem('dispName', fields[0].value.trim());
                
                DismisFormModal()
                navigate('/userPage')
                
            } else (
                console.log('Mensagem de erro')
            )
        }, (error) => {
            alert('Não foi possivel comunicar com o servidor! Click em ok para tentar reconnectar...')
            saveDispName(fields)
        });
    }

    function verefyIDPost(generatedId) {
        var id = generatedId;
        axios.post(apiBaseUrl + 'UniqueIdDisp/verifyUniqueIdDisp?uniqueId=' + id, { timeout: 50000 }).then((response) => {
            if (!Object.keys(response.data).length) {
                ShowFormModal(
                    {
                        modaltype: 'nameRegist'
                    })
            } else {
                if (Object.keys(response.data).length > 1) {
                    ShowMessageModal(
                        {
                            modaltype: 'warning',
                            modalTitle: 'Resgistos duplicados',
                            modalMessage: 'Existe mais do que um registo na base de dados. \n Por favor notifique o administrador deste problema.'
                        })
                } else {
                    //verifica se já pode entrar ou não na aplicação
                    if (response.data[0].nome === '') {
                        //Mostra forme
                        ShowFormModal(
                            {
                                modaltype: 'nameRegist'
                            })
                    } else {
                        navigate('/userPage')
                    }
                }
            }
        }, (error) => {
            alert('Não foi possivel comunicar com o servidor! Click em ok para tentar reconnectar...')
            verefyIDPost(generatedId)
        });
    }


    function virtualkeyboard() {
        document.onkeydown = (e) => {

            if (e.isTrusted) {
                return;
            }

            let xActiveEl = document.activeElement
            if (xActiveEl === null || xActiveEl === undefined) {
                return;
            }

            if (!(xActiveEl.nodeName.toUpperCase() === 'INPUT')) {
                return;
            }

            let xTypeInput = xActiveEl.type === undefined ? "Text" : xActiveEl.type;
            if (!(['PASSWORD', 'SEARCH', 'TEXT', 'TEXTAREA'].includes(xTypeInput.toUpperCase()))) {
                return;
            }
            let xPattern = xActiveEl.pattern;

            /*Caracteres possveis de escrever*/
            let xKeyCode = e.keyCode;
            let xValue = xActiveEl.value;
            let xReturn = xValue;
            let xSelPosiI = xActiveEl.selectionStart;
            let xSelPosiE = xActiveEl.selectionEnd;
            let xNewPosi = (xSelPosiI > xSelPosiE ? xSelPosiE : xSelPosiI);



            if ((xKeyCode >= 48 && xKeyCode <= 90) || (xKeyCode >= 96 && xKeyCode <= 105) || xKeyCode === 8 || xKeyCode === 46) {
                xReturn = xValue.substring(0, xSelPosiI) + xValue.substring(xSelPosiE);

                //Se backspace
                if (xKeyCode === 8) {
                    if (xSelPosiI === xSelPosiE) {
                        xReturn = xValue.substring(0, xSelPosiI - 1);
                        xReturn += xValue.substring(xSelPosiE);
                        xNewPosi += (xSelPosiI === 0 ? 0 : -1);
                    }
                }
                //Se For Delete
                else if (xKeyCode === 46) {
                    if (xSelPosiI === xSelPosiE) {
                        xReturn = xValue.substring(0, xSelPosiI);
                        xReturn += xValue.substring(xSelPosiE + 1);
                    }
                }
                else if (((xPattern.toUpperCase() === "[0-9]*" && (xKeyCode >= 48 && xKeyCode <= 57)) || (xKeyCode >= 96 && xKeyCode <= 105)) || !(xPattern.toUpperCase() === "[0-9]*")) {
                    xReturn = xValue.substring(0, xSelPosiI) + e.key;
                    xReturn += xValue.substring(xSelPosiE);
                    xNewPosi += 1
                }
            }

            xActiveEl.readOnly = true;
            xActiveEl.value = xReturn;
            xActiveEl.selectionStart = xNewPosi;
            xActiveEl.selectionEnd = xActiveEl.selectionStart;
            setTimeout(function () { xActiveEl.readOnly = false; }, 150);

            xActiveEl.dispatchEvent(new KeyboardEvent("keydown", {
                key: e.key,
                keyCode: e.keyCode, 	// example values.
                code: e.code, 		// put everything you need in this object.
                which: e.which,
                shiftKey: e.shiftKey, 		// you don't need to include values
                ctrlKey: e.ctrlKey,  		// if you aren't going to use them.
                metaKey: e.metaKey   		// these are here for example's sake.
            }));

        }
    }

    return (
        <globalFunctions.Provider value={{
            //---Variaveis
            //Variaveis para a função advancedClick
            lastTouchTimeStamp: state.lastTouchTimeStamp,
            lastClickTimeStamp: state.lastClickTimeStamp,
            lastMouseTimeStamp: state.lastMouseTimeStamp,
            //---Fim Variaveis

            //---Funções
            //t = text, n = number, a = object/array b= boolean, d= date

            //Click functions
            advancedClick: (a, n) => advancedClick(a, n),
            VerefyIDPost: (t) => verefyIDPost(t),
            SaveDispName: (fields) => saveDispName(fields),
            Virtualkeyboard: () => virtualkeyboard(),

            //Fim Funções
        }}>
            {params.children}
        </globalFunctions.Provider>
    )
}

export default GlobalFunctions